import { render } from "./ArtistItem.vue?vue&type=template&id=279aa2a3&scoped=true"
import script from "./ArtistItem.vue?vue&type=script&lang=js"
export * from "./ArtistItem.vue?vue&type=script&lang=js"

import "./ArtistItem.vue?vue&type=style&index=0&id=279aa2a3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aidan\\Documents\\Code\\spotify-vue\\hilow\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279aa2a3"]])

export default __exports__